import { Card, Col, Descriptions, Row, Typography, message } from "antd";
import ListTable from "common/ListTable";
import { DIGITALIZATION_ABSENT_LIST } from "apiServices/API_ENDPOINTS";
import { getData } from "apiServices/common";
import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router";

export default function OperatorAbsenteeismView() {
  const [checklistData, setChecklistData] = useState(null);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const getSupervisorChecklist = useCallback(async () => {
    setLoading(true);
    const query = `${DIGITALIZATION_ABSENT_LIST}/${id}`;
    const response = await getData(query);
    setLoading(false);
    if (response?.status === 200) {
      setChecklistData(response?.data?.data || {});
    } else {
      message.error("Something went wrong! Please try again.");
    }
  }, [id]);

  useEffect(() => {
    getSupervisorChecklist();
  }, [id, getSupervisorChecklist]);

  console.log({ checklistData });

  return (
    <Row gutter={4}>
      <Col span={24}>
        <Card
          title={
            <Typography.Title level={4}>Absenteeism Info</Typography.Title>
          }
          bordered
          style={{
            margin: "10px 20px",
            padding: "10px",
          }}
        >
          <Descriptions column={4}>
            <Descriptions.Item label="Supervisor Name">
              {" "}
              <Typography.Text level={2} strong>
                {checklistData?.user?.name}
              </Typography.Text>
            </Descriptions.Item>
            <Descriptions.Item label="Phone">
              {" "}
              <Typography.Text level={2} strong>
                {checklistData?.user?.phone}
              </Typography.Text>
            </Descriptions.Item>
            <Descriptions.Item label="Email">
              {" "}
              <Typography.Text level={2} strong>
                {checklistData?.user?.email}
              </Typography.Text>
            </Descriptions.Item>
            <Descriptions.Item label="Line">
              {" "}
              <Typography.Text level={2} strong>
                {checklistData?.line_info?.name}
              </Typography.Text>
            </Descriptions.Item>
            <Descriptions.Item label="Date">
              {" "}
              <Typography.Text level={2} strong>
                {checklistData?.date}
              </Typography.Text>
            </Descriptions.Item>
          </Descriptions>

          <Typography.Title level={5} style={{ marginTop: "20px", marginBottom: "10px" }}>
            Operator Details
          </Typography.Title>
          <ListTable
            loading={loading}
            dataSource={checklistData?.details || []}
            rowKey="id"
            pagination={false}
            bordered
            size="small"
            emptyText="No records to show yet."
            columns={[
              {
                title: "Sl",
                dataIndex: "sl",
                key: "sl",
                width: 60,
                render: (_, __, index) => index + 1,
              },
              {
                title: "Operator Name",
                dataIndex: ["operator", "name"],
                key: "operator_name",
              },
              {
                title: "ID Card",
                key: "id_card_no",
                render: (_, record) => record?.operator?.additional_info?.id_card_no ?? '-',
              },
              {
                title: "Operator Phone",
                dataIndex: ["operator", "phone"],
                key: "operator_phone",
              },
              {
                title: "Operator Email",
                dataIndex: ["operator", "email"],
                key: "operator_email",
              },
              {
                title: "Reason",
                dataIndex: ["reason", "reason"],
                key: "reason",
              },
              {
                title: "Informed in Advance?",
                dataIndex: "is_informed_advance",
                key: "is_informed_advance",
              },
              {
                title: "Supervisor Contacted?",
                dataIndex: "is_superviser_contacted",
                key: "is_superviser_contacted",
              },
              {
                title: "Worker Response",
                dataIndex: "worker_response",
                key: "worker_response",
              },
              {
                title: "Notes",
                dataIndex: "notes",
                key: "notes",
              },
            ]}
          />
        </Card>
      </Col>
    </Row>
  );
}
